var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand=Mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard-color_large"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 54,
    height: 36,
    rx: 4,
    fill: "#F2F0EC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5.23114,
    y: 3.60001,
    width: 43.5487,
    height: 28.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 21.2623,
    y: 8.61752,
    width: 11.4862,
    height: 18.765,
    fill: "#F26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M22.4999 18C22.481 14.3477 24.1399 10.8889 26.9999 8.6175C22.1065 4.76921 15.0771 5.32803 10.8531 9.90114C6.62915 14.4742 6.62915 21.5258 10.8531 26.0989C15.0771 30.672 22.1065 31.2308 26.9999 27.3825C24.1399 25.1111 22.481 21.6523 22.4999 18Z",
    fill: "#EA1D25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1574 25.0088V25.3913H45.0899V25.0088H44.9324V24.93H45.3261V25.0088H45.1574ZM45.9224 24.93V25.3913H45.8436V25.0425L45.7199 25.3463H45.6299L45.4949 25.0425V25.3913H45.4161V24.93H45.5286L45.6749 25.2563L45.8099 24.93H45.9224Z",
    fill: "#F69E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M46.3049 18C46.302 22.5668 43.6936 26.7316 39.5863 28.7278C35.4789 30.7241 30.5926 30.2018 26.9999 27.3825C32.175 23.3077 33.0712 15.8111 29.0024 10.6313C28.4192 9.88119 27.7467 9.20496 26.9999 8.61751C30.5926 5.79826 35.4789 5.27598 39.5863 7.27221C43.6936 9.26844 46.302 13.4333 46.3049 18Z",
    fill: "#F69E1E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.0ddd7b2821bf2be74e76c53839b20d22.svg";
export { ForwardRef as ReactComponent };